import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"

const EUROS = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" })

/**
 * Montant en euros à la française (« 3 600,00 € »). Les Decimal arrivent en
 * chaîne de l'API malgré leur type `number` : l'appelant passe `Number(...)`.
 */
export function formatEuro(amount: number): string {
  return EUROS.format(amount)
}

/** Montant servi en nombre, ou Decimal en chaîne. */
type AmountValue = number | string

/**
 * Montant en euros, ou « Non renseigné » s'il manque.
 * Un Decimal en chaîne est accepté tel quel.
 *
 * @example
 * formatOptionalEuro(O.some("1250.50")) // "1 250,50 €"
 * formatOptionalEuro(O.none) // "Non renseigné"
 */
export function formatOptionalEuro(amount: O.Option<AmountValue>): string {
  return pipe(
    amount,
    O.match(
      () => "Non renseigné",
      (value) => formatEuro(Number(value)),
    ),
  )
}

const RATE = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 })

/** Taux de TVA à la française (« 20 % », « 5,5 % ») ; le Decimal arrive en chaîne. */
export function formatTaxRate(rate: number): string {
  return `${RATE.format(Number(rate))} %`
}

/** Quantité d'une ligne à la française (« 14 », « 1,5 ») ; le Decimal arrive en chaîne (« 14.00 »). */
export function formatQuantity(quantity: number | string): string {
  return RATE.format(Number(quantity))
}
